import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { TextLoca } from "../generic/text/TextLoca";
import { mapDialogLeagueRewardsDescription } from "./MapDialogLeagueRewardsDescription";
export var DescriptionDialogLeagueReward = function (_a) {
    var currentGift = _a.currentGift, packageType = _a.packageType;
    var isCurrentGiftNotPayable = !currentGift.cost || !currentGift.cost[0];
    var mapToUse = mapDialogLeagueRewardsDescription.get(currentGift.leagueType) ||
        new Map([]);
    var description = mapToUse.get(packageType);
    if (!description || isCurrentGiftNotPayable) {
        return React.createElement(React.Fragment, null);
    }
    var replacements = getReplacements(currentGift);
    return (React.createElement(TextLoca, { className: IdStyles.TextBoldAccent, id: description, replacements: replacements }));
};
var getReplacements = function (currentGift) {
    var goldToReceive = currentGift.resourceReward[0].amount;
    var goldToPay = currentGift.cost[0].amount;
    var goldPercentage = Math.round((goldToReceive / goldToPay - 1) * 100);
    return new Map([[ReplacementLoca.zero_0, utilNumber.format(goldPercentage)]]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/DescriptionDialogLeagueReward.tsx
// module id = 2944
// module chunks = 3